import * as React from "react";

import { Viewport, ViewSmall, ViewMedium } from "@shared-ui/viewport-context";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";

import { ExtendedFTNode } from "typings/flexFramework/FlexComponent";
import { LobFormWithTabs } from "components/shared/StorefrontWizard/LobFormWithTabs/LobFormWithTabs";
import { LobQueryRouter } from "components/shared/StorefrontWizard/LobQueryRouter";
import { SingleSearchEntry } from "src/components/shared/StorefrontWizard/SingleSearchEntry/SingleSearchEntry";
import { Experiment as Experiments } from "components/utility/experiment";

interface TabbedWizardProps {
  wizardLOBs: ExtendedFTNode[];
  context: any;
  wizardFormChildren: React.ReactElement[];
  trackOnChangeTab?: (tab: string) => void;
  aboveOtherFormChildren?: React.ReactElement[];
  belowOtherFormChildren?: React.ReactElement[];
}

export const WizardTabbed = ({
  wizardLOBs,
  context,
  wizardFormChildren,
  trackOnChangeTab,
  aboveOtherFormChildren,
  belowOtherFormChildren,
}: TabbedWizardProps) => {
  const forms = (
    <LobFormWithTabs
      context={context}
      lobForms={wizardFormChildren}
      wizardFormClassNames="all-x-padding-six"
      tabGroupClassNames="all-l-padding-six"
      trackOnChangeTab={trackOnChangeTab}
    />
  );

  return (
    <>
      <LobQueryRouter lobs={wizardLOBs} />
      {aboveOtherFormChildren}

      <Viewport>
        <ViewSmall>
          <Experiment name={Experiments.Home_Simplified_Search_Entry}>
            <ExperimentControl>{forms}</ExperimentControl>
            <ExperimentVariant bucket={1}>
              <SingleSearchEntry>{forms}</SingleSearchEntry>
            </ExperimentVariant>
            <ExperimentVariant bucket={2}>
              <SingleSearchEntry>{forms}</SingleSearchEntry>
            </ExperimentVariant>
          </Experiment>
        </ViewSmall>

        <ViewMedium>{forms}</ViewMedium>
      </Viewport>

      {belowOtherFormChildren}
    </>
  );
};
